import { LicenseCode } from './LicenseCode';
import { AccountState as LicenseState } from './IAccount';

export interface License {
  code: LicenseCode;
  displayName: string;
  type: string;
  enabled?: boolean;
  bootstrapable?: boolean;
  state?: LicenseState;
}

export enum LicensePackageCode {
  /** @deprecated Use `Send` instead */
  Lite = 'slim',
  Send = 'send',
  /** @deprecated Use `Automate` instead */
  Essential = 'standard',
  Automate = 'automate',
  /** @deprecated Use `Grow` instead */
  AllInOne = 'all',
  Grow = 'grow',
  Trial = 'trial',
  Freemium = 'freemium',
}

export interface LicensePackage {
  code: LicensePackageCode;
  displayName: string;
  licenses: LicenseCode[];
}

export namespace LiteQuotas {
  export const EmailQuota = 4000;
  export const UserSeats = 1;
  export const AudienceProfiles = 1000;
  export const SmsCredits = 0;
}

export namespace SendQuotas {
  export const EmailQuota = 10000;
  export const UserSeats = 1;
  export const AudienceProfiles = 20000;
  export const SmsCredits = 0;
}

export namespace EssentialQuotas {
  export const EmailQuota = 20000;
  export const UserSeats = 3;
  export const AudienceProfiles = 2500;
  export const SmsCredits = 0;
}

export namespace AutomateQuotas {
  export const EmailQuota = 20000;
  export const UserSeats = 3;
  export const AudienceProfiles = 50000;
  export const SmsCredits = 0;
}

export namespace AllInOneQuotas {
  export const EmailQuota = 60000;
  export const UserSeats = 3;
  export const AudienceProfiles = 5000;
  export const SmsCredits = 0;
}

export namespace GrowQuotas {
  export const EmailQuota = 50000;
  export const UserSeats = 3;
  export const AudienceProfiles = 100000;
  export const SmsCredits = 0;
}

export namespace TrialQuotas {
  export const EmailQuota = 2000;
  export const UserSeats = 1;
  export const AudienceProfiles = 1000;
  export const SmsCredits = 0;
}

export namespace FreemiumQuotas {
  export const EmailQuota = 5000;
  export const UserSeats = 1;
  export const AudienceProfiles = 0;
  export const SmsCredits = 0;
}
